import React from 'react';

import { useDraggable } from '@dnd-kit/core';
import cn from 'classnames';

import { formatPrice } from '@shared/helpers';
import { Flex, Icon, UiText } from '@shared/ui';
import { useIsOverflowingFields } from '@widgets/OrdersRecognition/lib/hooks';
import { TOrderItem } from '@widgets/OrdersRecognition/model/types';
import { DraggableEl } from '@widgets/OrdersRecognition/ui/Order/DraggableEl';
import { OrderAvatar } from '@widgets/OrdersRecognition/ui/Order/OrderAvatar';

import cls from './OrderPosition.module.css';

interface IOrderPositionProps {
    orderPosition: TOrderItem['positions'][number] & {
        supplier: TOrderItem['supplier'];
        comment: TOrderItem['displayString'];
        documentDate: TOrderItem['documentDate'];
        currency: TOrderItem['currency'];
    };
    className?: string;
    isCanEdit?: boolean;
}

export const OrderPosition = ({
    orderPosition = {},
    className,
    isCanEdit = false,
}: IOrderPositionProps) => {
    const {
        id,
        name,
        sum,
        isUsed,
        unit,
        amount,
        supplier,
        comment,
        price,
        documentDate,
        currency,
    } = orderPosition;
    const { attributes, listeners, setNodeRef } = useDraggable({
        id: `position-${id}`,
        data: {
            type: 'position',
            item: {
                id: orderPosition.id,
                name: orderPosition.name,
                sum,
                unit,
                amount,
                isUsed,
                supplier,
                comment,
                documentDate,
                price,
            },
        },
    });
    const {
        unitRef,
        amountRef,
        orderPositionNameRef,
        isUnitOverflowing,
        isAmountOverflowing,
        isOverflowing,
    } = useIsOverflowingFields();

    return (
        <Flex className={cn(isUsed && cls.isProceed, cls.OrderPositionContainer)} justify="between">
            {/* <Flex className={cn(isUsed && cls.isProceed, cls.OrderPositionContainer)} justify="between"> */}
            <Flex className={cn(cls.OrderPositionMain, className)} gap={8} ref={setNodeRef}>
                <OrderAvatar />
                {isCanEdit && <DraggableEl {...listeners} {...attributes} isProceed={isUsed} />}

                <UiText
                    variant="mediumPlain"
                    tag="span"
                    className={cls.PositionName}
                    ref={orderPositionNameRef}
                    title={isOverflowing ? name : ''}
                >
                    {name}
                </UiText>
            </Flex>

            <Flex gap={12} className={cn(cls.OrderPositionInfo)}>
                <UiText
                    className={cls.OrderPositionUnit}
                    align="right"
                    variant="mediumPlain"
                    ref={unitRef}
                    title={isUnitOverflowing ? unit : ''}
                >
                    {unit}
                </UiText>
                <span
                    className={cls.Amount}
                    ref={amountRef}
                    title={isAmountOverflowing ? String(amount) : ''}
                >
                    {amount}
                </span>
                <span className={cls.Sum}>
                    {formatPrice(sum, {
                        currencyCode: currency.code,
                        withCurrency: true,
                        maximumFractionDigits: 2,
                    })}
                </span>
                {isUsed && cls.isProceed && (
                    <Icon iconName="isChecked" className={cls.isCheckedIcon} />
                )}
                {/* {Number(id) % 2 === 0 && cls.isProceed && ( */}
                {/*    <Icon iconName="isChecked" className={cls.isCheckedIcon} /> */}
                {/* )} */}
                {/* {isUsed && <Icon iconName="isChecked" className={cls.isCheckedIcon} />} */}
            </Flex>
        </Flex>
    );
};
